import { DOCUMENT } from '@angular/common';
import { inject, InjectionToken } from '@angular/core';

import { fromEvent as observableFromEvent, Observable } from 'rxjs';
import { share } from 'rxjs/operators';

export const PWA_INSTALLED = new InjectionToken<Observable<Event | null>>(
  'PWA installed observer',
  {
    factory: () => {
      const { defaultView } = inject(DOCUMENT);
      if (!defaultView) throw new Error('Window is not available');

      return observableFromEvent(window, 'appinstalled').pipe(share());
    },
  },
);
